import Ajv from 'ajv';

export default function validate(schema, data) {
	let ajv = new Ajv({ allErrors:true });
	let valid = ajv.validate(schema, data);

	if (!valid) console.error(ajv.errorsText());
}
